import { render, staticRenderFns } from "./X-modale-recapitulatif-commande.vue?vue&type=template&id=639c6a10"
import script from "./X-modale-recapitulatif-commande.vue?vue&type=script&lang=js"
export * from "./X-modale-recapitulatif-commande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639c6a10')) {
      api.createRecord('639c6a10', component.options)
    } else {
      api.reload('639c6a10', component.options)
    }
    module.hot.accept("./X-modale-recapitulatif-commande.vue?vue&type=template&id=639c6a10", function () {
      api.rerender('639c6a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/X-modale-recapitulatif-commande.vue"
export default component.exports